import React, { Component, useState, useEffect, useRef } from "react";
import "../index.css";
import "./index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import { BsFillLightningChargeFill } from "react-icons/bs";
import CarouselReaction from "./CarouselReactions";
import {
  FaBolt,
  FaCheck,
  FaChevronLeft,
  FaChevronRight,
  FaRegCheckCircle,
} from "react-icons/fa";
import { AiOutlineClockCircle } from "react-icons/ai";
import ReactStars from "react-stars";
import Questions from "./Questions";

const Explainer = ({}) => {
  const carouselRef = useRef(null);

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 250, behavior: "smooth" }); // Adjust the value as needed
    }
  };

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -250, behavior: "smooth" }); // Adjust the value as needed
    }
  };

  return (
    <>
      <MDBRow
        style={{
          marginTop: -29,
          paddingTop: 0,
          paddingBottom: 100,
          paddingLeft: 0,
        }}
      >
        <MDBCol
          style={{ paddingLeft: 0 }}
          className="d-flex justify-content-center"
          size="12"
        >
          <MDBRow
            style={{
              marginTop: 0,
              color: "white",
              width: 820,
              overflowX: "hidden",
              paddingLeft: 0,
            }}
          >
            <MDBCol size="12">
              <hr
                style={{
                  width: 850,
                  height: 0.6,
                  backgroundColor: "rgb(63, 59, 69)",
                  marginTop: 20,
                }}
              />
            </MDBCol>
            <MDBCol
              style={{ marginTop: 24 }}
              className="d-flex justify-content-end"
              size="12"
            >
              <p
                style={{
                  fontFamily: "CSMedium",
                  fontSize: 20,
                  position: "absolute",
                  left: 16,
                  marginTop: 6,
                }}
              >
                Example videos
              </p>
              <div
                style={{
                  height: 36,
                  width: 36,
                  backgroundColor: "rgb(28, 28, 28)",
                  borderRadius: 100,
                  display: "inline-block",
                  marginRight: 10,
                  border: "1px solid rgb(62, 62, 62)",
                }}
                onClick={() => scrollLeft()}
                className="d-flex justify-content-center hover-border"
              >
                <FaChevronLeft
                  style={{
                    marginTop: 11,
                    fontSize: 12,
                    marginRight: 0,
                    opacity: 0.8,
                  }}
                />{" "}
              </div>
              <div
                style={{
                  height: 36,
                  width: 36,
                  borderRadius: 100,
                  display: "inline-block",
                  backgroundColor: "rgb(28, 28, 28)",
                  marginRight: -10,
                  border: "1px solid rgb(62, 62, 62)",
                }}
                onClick={() => scrollRight()}
                className="d-flex justify-content-center hover-border"
              >
                <FaChevronRight
                  style={{
                    marginTop: 11,
                    fontSize: 12,
                    marginLeft: 3,
                    opacity: 0.8,
                  }}
                />{" "}
              </div>
            </MDBCol>
            <MDBCol style={{ marginTop: 20 }} size="12">
              <CarouselReaction
                scrollLeft={scrollLeft}
                scrollRight={scrollRight}
                carouselRef={carouselRef}
              />
            </MDBCol>
            <MDBCol style={{ marginTop: -34, paddingLeft: 20 }} size="12">
              <div
                style={{
                  borderRight: "1px solid rgb(63, 59, 69)",
                  width: 160,
                  overflowY: "hidden",
                  display: "inline-block",
                  paddingBottom: 0,
                  height: 42,
                }}
              >
                <p style={{ fontFamily: "CSRegular", fontSize: 16 }}>
                  <BsFillLightningChargeFill
                    style={{ fontSize: 14, marginRight: 9, marginTop: -3 }}
                    className="d-inline"
                  />
                  Takes 2 minutes
                  <p
                    style={{
                      marginLeft: 24,
                      fontSize: 14,
                      fontFamily: "CSRegular",
                      opacity: 0.7,
                      marginTop: -2,
                    }}
                  >
                    Sent to your inbox
                  </p>
                </p>
              </div>
              <div
                style={{
                  borderRight: "0px solid rgb(63, 59, 69)",
                  width: 160,
                  overflowY: "hidden",
                  display: "inline-block",
                  marginLeft: 20,
                  height: 42,
                }}
              >
                <p style={{ fontFamily: "CSRegular", fontSize: 16 }}>
                  <AiOutlineClockCircle
                    style={{ fontSize: 14, marginRight: 9, marginTop: -3 }}
                    className="d-inline"
                  />
                  5 minutes
                  <p
                    style={{
                      marginLeft: 24,
                      fontSize: 14,
                      fontFamily: "CSRegular",
                      opacity: 0.7,
                      marginTop: -2,
                    }}
                  >
                    Max video length
                  </p>
                </p>
              </div>
            </MDBCol>
            <MDBCol size="12">
              <hr
                style={{
                  width: 850,
                  height: 0.6,
                  backgroundColor: "rgb(63, 59, 69)",
                  marginTop: 20,
                }}
              />
            </MDBCol>
            <MDBCol size="12">
              <p
                style={{ marginTop: 18, fontFamily: "CSMedium", fontSize: 23 }}
              >
                How it works
              </p>
              <p
                style={{
                  marginTop: -16,
                  fontFamily: "CSRegular",
                  fontSize: 15,
                  opacity: 0.8,
                }}
              >
                Create a personalised video from your favorite celebrity.
              </p>
            </MDBCol>
            <MDBCol
              className="d-flex justify-content-between"
              style={{ marginTop: 0, paddingRight: 102 }}
              size="12"
            >
              <div
                style={{
                  position: "relative", // Add this line
                  height: 50,
                  width: 50,
                  border: "1px solid rgb(63, 59, 69)",
                  borderRadius: 200,
                  display: "inline-block",
                  marginLeft: 0, // You might need to adjust this for the first circle
                }}
                className="d-flex justify-content-center circle"
              >
                <p
                  style={{
                    fontFamily: "CSMedium",
                    marginTop: 11,
                    fontSize: 20,
                  }}
                >
                  {" "}
                  1
                </p>
              </div>
              <div
                style={{
                  position: "relative", // Add this line
                  height: 50,
                  width: 50,
                  border: "1px solid rgb(63, 59, 69)",
                  borderRadius: 200,
                  display: "inline-block",
                }}
                className="d-flex justify-content-center circle"
              >
                <p
                  style={{
                    fontFamily: "CSMedium",
                    marginTop: 11,
                    fontSize: 20,
                  }}
                >
                  {" "}
                  2
                </p>
              </div>
              <div
                style={{
                  position: "relative", // Add this line
                  height: 50,
                  width: 50,
                  border: "1px solid rgb(63, 59, 69)",
                  borderRadius: 200,
                  display: "inline-block",
                }}
                className="d-flex justify-content-center circle"
              >
                <p
                  style={{
                    fontFamily: "CSMedium",
                    marginTop: 11,
                    fontSize: 20,
                  }}
                >
                  {" "}
                  3
                </p>
              </div>
              <div
                style={{
                  position: "relative", // Add this line
                  height: 50,
                  width: 50,
                  border: "1px solid rgb(63, 59, 69)",
                  borderRadius: 200,
                  display: "inline-block",
                }}
                className="d-flex justify-content-center circle"
              >
                <p
                  style={{
                    fontFamily: "CSMedium",
                    marginTop: 11,
                    fontSize: 20,
                  }}
                >
                  {" "}
                  4
                </p>
              </div>
            </MDBCol>
            <MDBCol
              className="d-flex justify-content-between"
              style={{
                marginTop: 9,
                paddingRight: 0,
                paddingLeft: 0,
                overflowX: "visible",
              }}
              size="12"
            >
              <div
                style={{
                  position: "relative", // Add this line
                  width: 200,
                  display: "inline-block",
                  marginLeft: 14, // You might need to adjust this for the first circle
                }}
              >
                <p
                  style={{
                    fontFamily: "CSMedium",
                    marginTop: 0,
                    fontSize: 19,
                  }}
                >
                  Choose a celebrity
                </p>
                <p
                  style={{
                    fontFamily: "CSRegular",
                    marginTop: -15,
                    fontSize: 13,
                    opacity: 0.7,
                    width: 200,
                  }}
                >
                  Choose your favorite celebrity
                  <br />
                  to create your video.
                </p>
              </div>
              <div
                style={{
                  position: "relative", // Add this line
                  width: 200,
                  display: "inline-block",
                  marginLeft: 20, // You might need to adjust this for the first circle
                }}
              >
                <p
                  style={{
                    fontFamily: "CSMedium",
                    marginTop: 0,
                    fontSize: 19,
                  }}
                >
                  Write a script
                </p>
                <p
                  style={{
                    fontFamily: "CSRegular",
                    fontSize: 13,
                    opacity: 0.7,
                    width: 200,
                    marginTop: -15,
                  }}
                >
                  Write what you want them
                  <br />
                  to say in the video.
                </p>
              </div>
              <div
                style={{
                  position: "relative", // Add this line
                  width: 200,
                  display: "inline-block",
                  marginLeft: 20, // You might need to adjust this for the first circle
                }}
              >
                <p
                  style={{
                    fontFamily: "CSMedium",
                    marginTop: 0,
                    fontSize: 19,
                  }}
                >
                  Get your video
                </p>
                <p
                  style={{
                    fontFamily: "CSRegular",
                    fontSize: 13,
                    opacity: 0.7,
                    width: 200,
                    marginTop: -15,
                  }}
                >
                  It takes a couple of minutes to create your video.
                </p>
              </div>
              <div
                style={{
                  position: "relative", // Add this line
                  width: 200,
                  display: "inline-block",
                  marginLeft: 20, // You might need to adjust this for the first circle
                }}
              >
                <p
                  style={{
                    fontFamily: "CSMedium",
                    marginTop: 0,
                    fontSize: 19,
                  }}
                >
                  Upgrade
                </p>
                <p
                  style={{
                    fontFamily: "CSRegular",
                    fontSize: 13,
                    opacity: 0.7,
                    width: 130,
                    marginTop: -15,
                  }}
                >
                  Create longer videos with more celebrities.
                </p>
              </div>
            </MDBCol>
            <MDBCol size="12">
              <hr
                style={{
                  width: 850,
                  height: 0.6,
                  backgroundColor: "rgb(63, 59, 69)",
                  marginTop: 20,
                }}
              />
            </MDBCol>
            <MDBCol className="d-flex justify-content-between" size="12">
              <p
                style={{ marginTop: 38, fontFamily: "CSMedium", fontSize: 23 }}
              >
                What customers say about DarkGen
              </p>
            </MDBCol>
            <MDBCol size="12">
              <div
                style={{
                  height: 180,
                  width: 250,
                  backgroundColor: "rgb(32, 30, 35)",
                  borderRadius: 9,
                  display: "inline-block",
                  marginTop: 7,
                  paddingRight: 9,
                  paddingBottom: 3,
                }}
              >
                <MDBRow style={{ paddingLeft: 30, marginTop: 20 }}>
                  <MDBCol size="3">
                    <p style={{ fontFamily: "CSMedium" }}>Mitch</p>
                  </MDBCol>
                  <MDBCol size="5">
                    <div style={{ marginTop: -1, marginLeft: -9 }}>
                      <ReactStars
                        color1={"#ffd700"}
                        color2={"#ffd700"}
                        count={5}
                        value={5}
                        edit={false}
                        className="d-inline"
                      />
                    </div>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontSize: 13,
                        fontFamily: "CSRegular",
                        opacity: 0.8,
                        marginTop: -10,
                      }}
                    >
                      December 30, 2023 • Birthday
                    </p>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontSize: 13,
                        fontFamily: "CSRegular",
                        opacity: 0.8,
                        marginTop: -6,
                      }}
                    >
                      This was an awesome birthday message I sent to my mum.
                      She's a big Beyonce fan!
                    </p>
                  </MDBCol>
                </MDBRow>
                <p
                  style={{
                    position: "absolute",
                    fontFamily: "CSMedium",
                    fontSize: 11,
                    marginLeft: 95,
                    opacity: 0.7,
                    marginTop: -3,
                  }}
                >
                  <FaRegCheckCircle
                    style={{ marginRight: 6, marginTop: -2.57, fontSize: 13 }}
                  />
                  VERIFIED PURCHASE
                </p>
              </div>

              <div
                style={{
                  height: 180,
                  width: 250,
                  backgroundColor: "rgb(32, 30, 35)",
                  borderRadius: 9,
                  display: "inline-block",
                  marginTop: 7,
                  paddingRight: 9,
                  paddingBottom: 3,
                  marginLeft: 9,
                }}
              >
                <MDBRow style={{ paddingLeft: 30, marginTop: 20, width: 400 }}>
                  <MDBCol size="3">
                    <p style={{ fontFamily: "CSMedium" }}>Anonymous</p>
                  </MDBCol>
                  <MDBCol size="5">
                    <div style={{ marginTop: -1, marginLeft: 3 }}>
                      <ReactStars
                        color1={"#ffd700"}
                        color2={"#ffd700"}
                        count={5}
                        value={5}
                        edit={false}
                        className="d-inline"
                      />
                    </div>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontSize: 13,
                        fontFamily: "CSRegular",
                        opacity: 0.8,
                        marginTop: -10,
                      }}
                    >
                      December 30, 2023 • Prank
                    </p>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontSize: 13,
                        fontFamily: "CSRegular",
                        opacity: 0.8,
                        width: 200,
                        marginTop: -6,
                      }}
                    >
                      This is so funny! I sent my Dad a video of Donald Trump
                      and he literally couldn't stop laughing.
                    </p>
                  </MDBCol>
                </MDBRow>
                <p
                  style={{
                    position: "absolute",
                    fontFamily: "CSMedium",
                    fontSize: 11,
                    marginLeft: 95,
                    opacity: 0.7,
                    marginTop: -3,
                  }}
                >
                  <FaRegCheckCircle
                    style={{ marginRight: 6, marginTop: -2.57, fontSize: 13 }}
                  />
                  VERIFIED PURCHASE
                </p>
              </div>
              <div
                style={{
                  height: 180,
                  width: 250,
                  backgroundColor: "rgb(32, 30, 35)",
                  borderRadius: 9,
                  display: "inline-block",
                  marginTop: 7,
                  paddingRight: 9,
                  paddingBottom: 3,
                  marginLeft: 9,
                }}
              >
                <MDBRow style={{ paddingLeft: 30, marginTop: 20, width: 300 }}>
                  <MDBCol size="3">
                    <p style={{ fontFamily: "CSMedium" }}>kristen</p>
                  </MDBCol>
                  <MDBCol size="5">
                    <div style={{ marginTop: -1, marginLeft: -9 }}>
                      <ReactStars
                        color1={"#ffd700"}
                        color2={"#ffd700"}
                        count={5}
                        value={5}
                        edit={false}
                        className="d-inline"
                      />
                    </div>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontSize: 13,
                        fontFamily: "CSRegular",
                        opacity: 0.8,
                        marginTop: -10,
                      }}
                    >
                      December 31, 2023 • Fun
                    </p>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontSize: 13,
                        fontFamily: "CSRegular",
                        opacity: 0.8,
                        width: 200,
                        marginTop: -6,
                      }}
                    >
                      It looks so realistic, it really looks like Jimin is
                      talking. This is def the scariest deepfake I've seen.
                    </p>
                  </MDBCol>
                </MDBRow>
                <p
                  style={{
                    position: "absolute",
                    fontFamily: "CSMedium",
                    fontSize: 11,
                    marginLeft: 95,
                    opacity: 0.7,
                    marginTop: -3,
                  }}
                >
                  <FaRegCheckCircle
                    style={{ marginRight: 6, marginTop: -2.57, fontSize: 13 }}
                  />
                  VERIFIED PURCHASE
                </p>
              </div>
            </MDBCol>
            <MDBCol size="12">
              <hr
                style={{
                  width: 850,
                  height: 0.6,
                  backgroundColor: "rgb(63, 59, 69)",
                  marginTop: 60,
                }}
              />
            </MDBCol>
            <MDBCol className="d-flex justify-content-between" size="12">
              <p
                style={{ marginTop: 48, fontFamily: "CSMedium", fontSize: 23 }}
              >
                Frequently asked questions
              </p>
            </MDBCol>
            <MDBCol size="12">
              <Questions />
            </MDBCol>
          </MDBRow>
        </MDBCol>
      </MDBRow>
    </>
  );
};

export default withRouter(Explainer);
